import { spacing } from '../spacing'
import { type ComponentCreation } from './types'

const fixedSettings = { minHeight: spacing(8), padding: spacing(1.5, 2) }
const fixedSettingsXl = { minHeight: spacing(7), padding: spacing(1, 2) }

export const createMuiToolbar = () =>
  ({
    MuiToolbar: {
      styleOverrides: {
        root: ({ theme }) => ({
          minHeight: spacing(theme.variant === 'xl' ? 7 : 8),
          padding: spacing(theme.variant === 'xl' ? 1 : 1.5, 2),
          [theme.breakpoints.up('xs')]: fixedSettings,
          [theme.breakpoints.up('md')]: theme.variant === 'xl' ? fixedSettingsXl : fixedSettings,
        }),
      },
    },
  }) satisfies ComponentCreation
